import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const n = r(
  (e, l) => /* @__PURE__ */ o.jsx(
    i,
    {
      ref: l,
      ...e,
      image: (a) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...a,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M2 1a1 1 0 0 1 1-1h6a1 1 0 0 1 .707.293l4 4A1 1 0 0 1 14 5v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm6.5 1L12 5.5H8.5z",
              clipRule: "evenodd"
            }
          )
        }
      )
    }
  )
);
n.displayName = "PlanIcon";
export {
  n as PlanIcon,
  n as default
};
//# sourceMappingURL=index.js.map
